var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 788,
    height: 365,
    viewBox: "0 0 788 365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-KudeoTradeMark"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 788,
    height: 365
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KudeoTradeMark",
    clipPath: "url(#clip-KudeoTradeMark)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M386.184,196.44a10.069,10.069,0,0,1-.154-12.927l55.579-67.869a4.045,4.045,0,0,0-3.122-6.6H410.676a4.067,4.067,0,0,0-3.122,1.473l-44.3,53.908a.951.951,0,0,1-.154.22l-1.3,1.517a1.437,1.437,0,0,1-.286.352,10.092,10.092,0,0,1-17.9-6.4V113.005a4.045,4.045,0,0,0-4.045-4.045h-24.8a4.067,4.067,0,0,0-4.045,4.045V271.74a4.045,4.045,0,0,0,4.045,4.023h24.8a4.023,4.023,0,0,0,4.045-4.023V221.833a10.091,10.091,0,0,1,17.742-6.6l50.809,59.119a4.067,4.067,0,0,0,3.056,1.385H445a4.023,4.023,0,0,0,3.078-6.6l-32.78-38.453Z",
    transform: "translate(-310.73 -10.534)",
    fill: "#090c3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M373.64,196.232V133.793a4.023,4.023,0,0,1,4.023-4.023h22.909a4.023,4.023,0,0,1,4.023,4.023v63.164c0,19.435,10.069,29.285,27.834,29.285S459.8,215.931,459.8,197.2V133.793a4.023,4.023,0,0,1,4.023-4.023h22.887a4.023,4.023,0,0,1,4.045,4.023V199.75c0,35.572-25.459,54.964-60.328,54.458a57.976,57.976,0,0,1-56.789-57.976Z",
    transform: "translate(-235.329 14.409)",
    fill: "#090c3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M541.022,107.94h21.7a4.023,4.023,0,0,1,4.023,4.023v161a4.023,4.023,0,0,1-4.023,4.023h-21.7a4.045,4.045,0,0,1-4.045-4.023V259.772a50.083,50.083,0,0,1-40.783,20.644c-35.528,0-60.724-28.317-60.724-63.362,0-36.232,25.921-64.791,61.691-64.791a47.4,47.4,0,0,1,39.816,20.886V111.963A4.045,4.045,0,0,1,541.022,107.94Zm-3.078,108.476a35.792,35.792,0,0,0-35.99-36.012,35.177,35.177,0,0,0-35.99,36.012c0,21.106,15.588,35.99,35.749,35.99a35.7,35.7,0,0,0,36.232-35.99Z",
    transform: "translate(-161.223 -11.755)",
    fill: "#090c3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M504.53,192.218c0-37.2,30.01-64.088,66.242-64.088s66.462,26.888,66.462,63.758S607.972,256.2,570.53,256.2C533.573,256.283,504.53,228.977,504.53,192.218Zm101.991-.242a35.639,35.639,0,0,0-71.277,0c0,20.864,15.61,36.232,35.177,36.232a35.4,35.4,0,0,0,36.1-36.232Z",
    transform: "translate(-78.451 12.442)",
    fill: "#090c3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M689.781,202.547H600.455c4.4,21.985,21.37,28.581,36.5,28.581a36.759,36.759,0,0,0,27.328-11.52,4,4,0,0,1,5.21-.528l14.884,10.355a4.09,4.09,0,0,1,.77,5.958c-11.631,14.137-29.131,20.93-48.676,20.93-39.838,0-65.517-27.35-65.517-64.066s26.163-64.088,62.878-64.088,60.7,28.317,60.7,61.691a76.753,76.753,0,0,1-.638,9.212,4.045,4.045,0,0,1-4.111,3.474Zm-23.9-21.59c-2.88-16.093-14.4-28.075-31.9-28.075-14.642,0-29.285,9.586-33.374,28.075Z",
    transform: "translate(1.156 12.492)",
    fill: "#090c3d"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u2122",
    transform: "translate(654.843 114)",
    fill: "#090c3d",
    fontSize: 55,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2122")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.89a7686fa38628b998b3496befc6d94d.svg";
export { ForwardRef as ReactComponent };